import React from 'react'
import PropTypes from 'prop-types'
import { Controller } from 'react-hook-form'
import { FormControl, TextField } from '@mui/material_modern'
import { TimePicker as MuiTimePicker } from '@mui/x-date-pickers'
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'

const TimePicker = ({ name, label, control, variant, defaultTime, timePickerProps, ...restProps }) => {
  const labelId = `${name}-label`

  return (
    <FormControl sx={{ width: '100%' }}>
      <LocalizationProvider dateAdapter={AdapterDateFns}>
        <Controller
          render={({ field: { onChange, value } }) => (
            <MuiTimePicker
              labelId={labelId}
              label={label}
              value={value}
              onChange={onChange}
              ampm
              {...timePickerProps}
              renderInput={params => (
                <TextField
                  variant={variant}
                  {...params}
                  {...restProps}
                  InputProps={{
                    ...(params.InputProps || {}),
                    ...(restProps.InputProps || {}),
                  }}
                />
              )}
            />
          )}
          name={name}
          control={control}
          defaultValue={defaultTime}
        />
      </LocalizationProvider>
    </FormControl>
  )
}

TimePicker.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  variant: PropTypes.string,
  defaultTime: PropTypes.instanceOf(Date),
  control: PropTypes.instanceOf(Object).isRequired,
  timePickerProps: PropTypes.object,
}

TimePicker.defaultProps = {
  variant: 'standard',
  defaultTime: null,
  timePickerProps: {},
}

export default TimePicker
